module.exports = __webpack_public_path__ + "static/media/md.8c3ffd4e.svg";